import { connectedRouterRedirect } from 'redux-auth-wrapper/history3/redirect';
import locationHelperBuilder from 'redux-auth-wrapper/history3/locationHelper';
import { routerActions } from 'react-router-redux';
import { isPartnerUser, isInternalUser } from '../utils/assessmentUtils';

const locationHelper = locationHelperBuilder({});

const baseConnectedRouterRedirectOptions = {
  redirectPath: '/login'
};

const createConnectedRouterRedirect = (wrapperDisplayName, selector) => {
  return connectedRouterRedirect(Object.assign({}, {
    authenticatedSelector: state => state.user.logged_in && selector(state.user),
    authenticatingSelector: state => state.user.loading,
    allowRedirectBack: false,
    redirectAction: routerActions.replace,
    wrapperDisplayName
  }, baseConnectedRouterRedirectOptions));
};

export const internalUserIsAuthenticated = createConnectedRouterRedirect(
  'InternalUserIsAuthenticated',
  user => isInternalUser(user)
);

export const externalUserIsAuthenticated = createConnectedRouterRedirect(
  'ExternalUserIsAuthenticated',
  user => !isInternalUser(user)
);

export const internalOrPartnerUserIsAuthenticated = createConnectedRouterRedirect(
  'InternalOrPartnerUserIsAuthenticated',
  user => isInternalUser(user) || isPartnerUser(user)
);

export const userIsNotAuthenticated = connectedRouterRedirect({
  redirectPath: (state, ownProps) => locationHelper.getRedirectQueryParam(ownProps) || '/',
  allowRedirectBack: false,
  authenticatedSelector: state => !state.user.logged_in,
  redirectAction: routerActions.replace,
  wrapperDisplayName: 'UserIsNotAuthenticated'
});



// WEBPACK FOOTER //
// ./src/routing/authWrappers.js